import { render, staticRenderFns } from "./cadastro_edicao_administrativo.vue?vue&type=template&id=e3d060cc&scoped=true"
import script from "./cadastro_edicao_administrativo.vue?vue&type=script&lang=js"
export * from "./cadastro_edicao_administrativo.vue?vue&type=script&lang=js"
import style0 from "./cadastro_edicao_administrativo.vue?vue&type=style&index=0&id=e3d060cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3d060cc",
  null
  
)

export default component.exports